import { render, staticRenderFns } from "./import-product-modal.vue?vue&type=template&id=c95e20d2&scoped=true&"
import script from "./import-product-modal.vue?vue&type=script&lang=js&"
export * from "./import-product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e20d2",
  null
  
)

export default component.exports